import { makeAutoObservable, runInAction } from 'mobx';
import { CRMService } from './service';
import {
  CRM_Metadata,
  CRM_MetadataInitialState,
  crmRegister,
  listObject,
  returntaskStatus,
  handleFindDifferences,
  sortNameReset,
} from './types';
import { toast } from 'react-toastify';
import agent from '../../api/agent';
import { Activity } from '../../models/activity';
import { store } from '../store';
import { v4 as uuid } from 'uuid';
import { historyPayloadType, updateHistoryMain } from '../../models/history';
import sendRespectiveEmail from '../../models/EmailNew';
import { createCRMAsset, createCRMAssetInitialState } from '../../models/Restoration';
import { Options } from 'jsbarcode';
export default class CRMStore {
  showButton = {
    Start: false,
    Complete: false,
  };
  MetaDatatemplate: CRM_Metadata[] = [CRM_MetadataInitialState];
  SubtaskGroupDetails: {
    subtask: string;
    count: number;
  }[] = [];
  logisticsSubtaskGroupDetails: {
    subtask: string;
    count: number;
  }[] = [];
  loader: {
    tableLoader: boolean;
    buttonLoader: boolean;
  } = {
    tableLoader: false,
    buttonLoader: false,
  };
  titileInformation: Activity[] = [];
  count: number = 0;
  subtaskCompoent: {
    templateId: string;
    apiSettings: any[];
    elements: CRM_Metadata[];
    logisticsElements: any[];
    selectedItemDetails: any;
    currentTaskId: string;
    currentSubtaskId: string;
    isModel: boolean;
    defaultMetadata: CRM_Metadata[];
    selectedRowDetails: { id: string; title: string };
  } = {
    templateId: '',
    apiSettings: [],
    elements: [],
    logisticsElements: [],
    selectedItemDetails: {},
    currentTaskId: '',
    currentSubtaskId: '',
    isModel: false,
    defaultMetadata: [],
    selectedRowDetails: { id: '', title: '' },
  };
  authorizationTable: { tableData: CRM_Metadata[]; count: number } = {
    tableData: [],
    count: 0,
  };
  logisticsTable: { tableData: CRM_Metadata[]; count: number } = {
    tableData: [],
    count: 0,
  };
  fileUploadDetails: string[] = [];
  activePage: string = '';
  authorizationModel: boolean = false;
  logistictextAreaElementId: {
    itemId: '';
    name: string;
    templateDatails: {};
  }[] = [];
  logisticsButton: {
    inWard: boolean;
    outWard: boolean;
  } = {
    inWard: false,
    outWard: false,
  };
  itAssetTableDetails: {
    tableData: any[];
    count: number;
    loader: boolean;
    pageNumber: number;
  } = {
    tableData: [],
    count: 0,
    loader: false,
    pageNumber: 0,
  };

  assetTracking: {
    loading:boolean
    tableData: any[];
    count: number;
    searchCount: number;
    isHistory: boolean;
    selectedId: string;
    SelectedRowFormData:createCRMAsset;
    isField:string,
    deptList:Options[]
    deptValue:string
    pageNumber:number
  } = { loading:false, tableData: [], count: 0, searchCount: 0, isHistory: false, selectedId: '',SelectedRowFormData: createCRMAssetInitialState, isField: '',deptList:[],deptValue:'',pageNumber:0 };
  constructor() {
    makeAutoObservable(this);
  }

  handleCRMMetaDataFieldName = async () => {
    try {
      const response = await CRMService.CRMMetaDataFieldName();
      runInAction(() => {
        this.MetaDatatemplate = response.data;
      });
    } catch (error) {
      console.log(error);
    }
  };
  handleCRMRegister = async (data: crmRegister) => {
    try {
      const reponse = await CRMService.Register(data);
      runInAction(() => {
        if (reponse.data !== '') {
          toast.success('Title Update Successfully...');
        }
      });
      return reponse.data;
    } catch (error) {
      console.log(error);
    }
  };
  handleSmartFlowTemplate = async () => {
    try {
      this.loader.tableLoader = true;
      let assetResult = await agent.AssetTypes.smartflowTemplate();

      runInAction(() => {
        const template = assetResult.data.filter((item: any) =>
          item.name.includes('Digitization Process'),
        );
        runInAction(() => {
          this.subtaskCompoent.templateId = template[0]?.id?.split('_')?.[2];
          this.handleSubtaskDetails();
        });
      });
    } catch (error) {
      this.loader.tableLoader = false;
      console.log(error);
    }
  };
  handleSubtaskDetails = async () => {
    try {
      const subtaskResponse =
        await agent.ProdPlanning.listProductionTaskTemplate({
          templateId: this.subtaskCompoent.templateId,
          currentTask: 'Film Digitization Workflow',
        });
      runInAction(() => {
        this.SubtaskGroupDetails = subtaskResponse.data;
        this.loader.tableLoader = false;
      });
    } catch (error) {
      this.loader.tableLoader = false;
      console.log(error);
    }
  };

  handleStatusUpdate = async (
    name: string,
    statusNumber: number,
    localMetatdata: CRM_Metadata[],
    pageNumber: number,
    selectedSubtask: string,
  ) => {
    try {
      this.subtaskCompoent.isModel = false;
      this.loader.buttonLoader = true;
      this.loader.tableLoader = true;
      const {
        currentTaskId,
        currentSubtaskId,
        selectedItemDetails: { id, title, current_task, current_subtask },
      } = this.subtaskCompoent;
      const statusPayload = {
        itemId: id || '',
        currentTask: current_task || '',
        currentSubtask: current_subtask || '',
        actionerName: store.userStore.user?.username || '',
        resolveSubtaskId: '',
        status: statusNumber,
      };
      const historyPayload = {
        taskId: currentTaskId,
        taskName: current_task,
        subTaskId: currentSubtaskId,
        subTaskName: current_subtask,
        status: `${store.userStore.user?.displayName} ${name} working on ${selectedSubtask} for  ${title}`,
        date: new Date(),
      };
      await agent.viewPage.workFlowProcessChanges(statusPayload);
      await agent.workflowStatus.sendAPITemp(
        currentSubtaskId,
        id,
        statusNumber.toString(),
      );
      await updateHistoryMain(historyPayload, true, true, true, id, title);
      sendRespectiveEmail(
        'edited',
        title,
        'Edited WorkFlow in Asset',
        '',
        '',
        '',
        `Dear ${store.userStore?.user?.displayName},<br/>\u00A0 This notification is to inform you that you have resolved "${current_subtask}" to "${store.userStore.user?.displayName}" for ${title}. <br/> <br/> Regards, <br/> info@honeycombmanager.com`,
        true,
      );
      if (statusNumber === 2) {
        store.dashboardStore.setTagPageNumFunc(1);
      }
      runInAction(() => {
        toast.success('Status Update Successfully...');
        toast.info('Email Send Successfully.');
        toast.info('History Updated Sucessfully.');
        this.handleComponentUpdate(
          localMetatdata,
          id,
          statusNumber,
          currentSubtaskId,
          current_subtask?.replaceAll('CRM', '')?.trim(),
          currentTaskId,
          current_task,
          title,
          pageNumber,
        );
        this.loader.buttonLoader = false;
      });
    } catch (error) {
      this.loader.buttonLoader = false;
      console.log(error);
    }
  };

  handleComponentUpdate = async (
    localMetatdata: CRM_Metadata[],
    itemId: string,
    status: number,
    subTaskId: string,
    subTaskName: string,
    taskId: string,
    taskName: string,
    title: string,
    pageNumber: number,
  ) => {
    try {
      const list: listObject[] = [];
      const newlist = handleFindDifferences(
        localMetatdata,
        this.subtaskCompoent.defaultMetadata,
      );
      newlist.forEach(async (elem) => {
        const { elementName, elementValue } = elem;
        let viewTemplatepayload = {
          id: uuid(),
          itemId,
          taskId,
          taskName,
          subTaskName,
          subTaskId,
          elementName,
          elementValue,
          dateTime: new Date().toISOString(),
          status: returntaskStatus(status),
        };
        const historyPayload = {
          taskId,
          taskName,
          subTaskId,
          subTaskName,
          status: `${store.userStore.user?.displayName} set "${elem.elementName}" as "${elem.elementValue}" for ${title}`,
          date: new Date(),
        };
        await agent.TaskFormTaskServices.updateComponentsValuesInHistory(
          viewTemplatepayload,
        );
        await updateHistoryMain(
          historyPayload,
          true,
          false,
          true,
          itemId,
          title,
        );
        sendRespectiveEmail(
          'edited',
          title,
          'Edited WorkFlow in Asset',
          '',
          '',
          '',
          `Dear ${store.userStore?.user?.displayName},<br/>\u00A0 This notification is to inform you that you have  set ${elem.elementName} as ${elem.elementValue} for ${title}". <br/> <br/> Regards, <br/> info@honeycombmanager.com`,
          true,
        );
        const listPayload = {
          id: elementName,
          value: elementValue,
        };
        list.push(listPayload);
      });
      const payload = localMetatdata.map((e) => {
        return { id: e.elementId, value: e.elementValue };
      });
      await agent.workflowSubtasks.updateElementDetailsAPI(payload);
      this.buttonShowHandler();
      this.handleTableDetails(
        pageNumber,
        'Film Digitization Workflow',
        subTaskName,
      );
      if (status === 2) {
        this.handleSubtaskDetails();
        if (subTaskName === 'Deliverables') {
          this.activePage = 'Logistics';
        }
      }
    } catch (error) {
      console.log(error);
    }
  };
  handleTableDetails = async (
    pageNumber: number,
    currentTask: string,
    currentSubtask: string,
  ) => {
    try {
      this.loader.tableLoader = true;
      const [response, count] = await Promise.all([
        CRMService.crmSmartTrackItem(pageNumber, currentTask, currentSubtask),
        CRMService.crmSmartTrackCount(currentTask, currentSubtask),
      ]);
      runInAction(() => {
        const keysToExtract =
          (localStorage.getItem(`CRM ${currentSubtask}`) || '').split(',') ||
          [];
        this.titileInformation = this.tableDestructure(
          keysToExtract,
          response.data,
        );
        this.count = count.data;
        this.loader.tableLoader = false;
      });
    } catch (error) {
      this.loader.tableLoader = false;
      console.log(error);
    }
  };
  buttonShowHandler = () => {
    this.showButton = {
      Start: false,
      Complete: false,
    };
  };
  activeRowHandler = async (rowData: Activity, name: string) => {
    try {
      this.loader.buttonLoader = true;
      this.subtaskCompoent.isModel = true;
      this.buttonShowHandler();
      if (rowData.status === 'NA' || rowData.status === 'Yet to Start') {
        this.showButton.Start = true;
      } else if (rowData.status === 'Started') {
        this.showButton.Complete = true;
      }
      const response = await agent.viewPage.activeOrder({ itemId: rowData.id });
      const task = response.data.tasks.filter(
        (task) => task.taskName === 'Film Digitization Workflow',
      )?.[0];
      const taskId = task?.taskId;
      const subTaskId = task?.subTasks.filter(
        (subTask) => subTask.subTaskName === name?.replaceAll('CRM', '').trim(),
      )?.[0]?.subTaskId;

      let results = await agent.subtaskStatus.subtaskElementsAPI(subTaskId);

      runInAction(() => {
        this.elementDetailsApiCall(
          results.data.elements,
          rowData,
          response?.data?.templateId,
        );
        this.subtaskCompoent.apiSettings = results.data.api;
        this.subtaskCompoent.selectedItemDetails = {
          id: rowData.id,
          title: rowData.title,
          current_task: 'Film Digitization Workflow',
          current_subtask: name?.replaceAll('CRM', '')?.trim(),
        };
        this.subtaskCompoent.currentTaskId = taskId;
        this.subtaskCompoent.currentSubtaskId = subTaskId;
        this.loader.buttonLoader = false;
      });
    } catch (error) {
      this.loader.buttonLoader = false;
      console.log(error);
    }
  };

  elementDetailsApiCall = async (
    data: any[],
    rowData: Activity,
    templateId: string,
  ) => {
    try {
      let list: any = [];
      data.forEach(async (element) => {
        let params = {
          itemId: rowData?.id,
          templateId: templateId || '',
          templateElementId: element.elementValue.split('|')[1] || '',
        };
        let result = await agent.ElementTypes.elementDetails(params);
        let data: any = result?.data;
        if (data) {
          let payload = {
            ...data,
            readOnly: !!element?.readOnly,
            isMandatory: !!element?.isMandatory,
            enableByDefault: !!element?.enableByDefault,
            isDynamic: true,
          };
          list.push(payload);
        }
        this.subtaskCompoent.defaultMetadata = list;
        this.subtaskCompoent.elements = list;
      });
    } catch (error) {
      console.log(error);
    }
  };
  handleApproveTable = async (pageNumber: number) => {
    try {
      this.loader.tableLoader = true;
      const [response, count] = await Promise.all([
        CRMService.UnauthorisedItems(pageNumber),
        CRMService.UnauthorisedItemsCount(),
      ]);
      runInAction(() => {
        const keysToExtract =
          (localStorage.getItem('CRM Authorization') || '').split(',') || [];
        const extractedData = this.tableDestructure(
          keysToExtract,
          response.data,
        );
        this.authorizationTable.tableData = extractedData;
        this.authorizationTable.count = count.data;
        this.loader.tableLoader = false;
      });
    } catch (error) {
      this.loader.tableLoader = false;
      console.log(error);
    }
  };
  updateApproveTable = async (
    itemId: string,
    ItemStatus: boolean,
    itemName: string,
  ) => {
    try {
      const payload: historyPayloadType = {
        taskId: '',
        taskName: '',
        subTaskId: '',
        subTaskName: '',
        status: `${store.userStore.user?.displayName} authorized ${itemName}`,
        date: new Date(),
      };
      await CRMService.ApprovedAuthorizedItems(itemId, ItemStatus);
      await store.viewStore.addHistory({ itemId }, payload, true, true);
      runInAction(() => {
        toast.success(`${itemName} updated successfully.`);
      });
    } catch (error) {
      console.log(error);
    }
  };

  tableDestructure = (keysToExtract: string[], response: any) => {
    const extractedData = response?.map((element: any) => {
      const extractedObject: any = {};
      element?.metadata?.forEach((values: any) => {
        keysToExtract?.forEach((item: any) => {
          if (
            values?.elementName?.toLowerCase().replaceAll(/ /g, '_') ===
              'inward_remarks' &&
            item === values.elementName?.toLowerCase().replaceAll(/ /g, '_')
          ) {
            extractedObject[item?.replaceAll(/ /g, '_')] =
              values.elementValue?.replaceAll('|', ',');
            const payload = {
              itemId: element.id,
              name: 'InWard',
              templateDatails: values,
            };
            this.logistictextAreaElementId.push(payload);
          } else if (
            values?.elementName?.toLowerCase().replaceAll(/ /g, '_') ===
              'outward_remarks' &&
            item === values.elementName?.toLowerCase().replaceAll(/ /g, '_')
          ) {
            extractedObject[item?.replaceAll(/ /g, '_')] =
              values.elementValue?.replaceAll('|', ',');
            const payload = {
              itemId: element.id,
              name: 'OutWard',
              templateDatails: values,
            };
            this.logistictextAreaElementId.push(payload);
          } else if (
            values?.elementName?.toLowerCase().replaceAll(/ /g, '_') ===
            item?.toLowerCase().replaceAll(/ /g, '_')
          ) {
            extractedObject[item?.replaceAll(/ /g, '_')] =
              values.elementValue?.replaceAll('|', ',');
          }
        });
      });
      Object.entries(element).forEach(([key, value]: [string, any]) => {
        keysToExtract?.forEach((item: any) => {
          if (key === 'title' && key === item) {
            extractedObject[item?.replaceAll(/ /g, '_')] = value
              ?.split('-')?.[0]
              ?.trim();
          } else if (
            key?.toLowerCase().replaceAll(/ /g, '_') ===
            item?.toLowerCase().replaceAll(/ /g, '_')
          ) {
            extractedObject[item?.replaceAll(/ /g, '_')] = (
              value as string
            )?.replaceAll('|', ',');
          }
        });
      });
      extractedObject['id'] = element?.id;
      return extractedObject;
    });
    return extractedData;
  };
  handleAuthorizationModel = () => {
    this.authorizationModel = false;
    this.fileUploadDetails = [];
  };

  handleDeliveryL3 = async () => {
    try {
      const response = await CRMService.DeliveryL3();
      runInAction(() => {
        this.logisticsSubtaskGroupDetails = response.data;
      });
    } catch (error) {}
  };
  handleInwardTable = async (pageNumber: number) => {
    try {
      this.loader.tableLoader = true;
      let [respone, count]: any = await Promise.all([
        CRMService.crmInwardDeliveryItem(pageNumber),
        CRMService.crmInwardDeliveryTrackCount(),
      ]);
      runInAction(() => {
        const keysToExtract =
          (localStorage.getItem('CRM InWard') || '').split(',') || [];
        const extractedData = this.tableDestructure(
          keysToExtract,
          respone.data,
        );
        this.logisticsTable.tableData = extractedData;
        this.logisticsTable.count = count.data;
        this.loader.tableLoader = false;
      });
    } catch (error) {
      this.loader.tableLoader = false;
      console.log(error);
    }
  };
  handleOutwardTable = async (pageNumber: number) => {
    try {
      this.loader.tableLoader = true;
      let [respone, count]: any = await Promise.all([
        CRMService.crmOutwardDeliveryItem(pageNumber),
        CRMService.crmOutwardDeliveryTrackCount(),
      ]);
      runInAction(() => {
        const keysToExtract =
          (localStorage.getItem('CRM OutWard') || '').split(',') || [];
        const extractedData = this.tableDestructure(
          keysToExtract,
          respone.data,
        );
        this.logisticsTable.tableData = extractedData;
        this.logisticsTable.count = count.data;
        this.loader.tableLoader = false;
      });
    } catch (error) {
      this.loader.tableLoader = false;
      console.log(error);
    }
  };
  handlelogisticsButton = () => {
    this.logisticsButton.inWard = false;
    this.logisticsButton.outWard = false;
  };
  handleLogisticCompoentShow = async (
    name: string,
    itemId: string,
    templateDatails: any,
  ) => {
    try {
      this.subtaskCompoent.logisticsElements = [];
      this.subtaskCompoent.isModel = true;
      this.handlelogisticsButton();
      name === 'CRM InWard'
        ? (this.logisticsButton.inWard = true)
        : (this.logisticsButton.outWard = true);
      const payload = {
        itemId: itemId,
        templateId: templateDatails?.elementId || '',
        templateElementId: templateDatails?.templateElementId || '',
      };
      let result = await agent.ElementTypes.elementDetails(payload);
      runInAction(() => {
        this.subtaskCompoent.logisticsElements = [result.data];
      });
    } catch (error) {
      this.subtaskCompoent.isModel = false;
      console.log(error);
    }
  };
  updateLogisticsTable = async (
    itemId: string,
    name: string,
    params: { id: string; value: string },
  ) => {
    try {
      this.subtaskCompoent.isModel = false;
      this.subtaskCompoent.logisticsElements = [];
      const payload: historyPayloadType = {
        taskId: '',
        taskName: '',
        subTaskId: '',
        subTaskName: '',
        status: `${store.userStore.user?.displayName} ${name.toLowerCase()}ed successfully.`,
        date: new Date(),
      };
      await agent.workflowSubtasks.updateElementDetailsAPI([params]);
      await CRMService.UpdateDeliveryMovement(
        itemId,
        name === 'InWard' ? 'Inward' : name,
      );
      await store.viewStore.addHistory({ itemId }, payload, true, true);
      runInAction(() => {
        this.handleDeliveryL3();
        if (name === 'OutWard') this.handleOutwardTable(1);
        toast.success(
          `${name.charAt(0).toUpperCase() + name.slice(1)} updated successfully.`,
        );
      });
    } catch (error) {
      console.log(error);
    }
  };

  handleInventorySearch = async (pageNumber: number, searchData: string) => {
    try {
      this.itAssetTableDetails.loader = true;
      const [respone, count] = await Promise.all([
        CRMService.ItAssetInventoryItemsSearch(
          pageNumber,
          searchData === 'null' ? '' : searchData,
          10,
        ),
        CRMService.ItAssetInventoryItemsSearchCount(
          searchData === 'null' ? '' : searchData,
        ),
      ]);
      runInAction(() => {
        respone.data = respone.data.map((e: any) => ({
          ...e,
          title: e.title?.split('~')[0]?.split('-')[0] || '',
        }));
        // respone.data.title = respone.data?.title?.split('~')[0]?.split('-')[0] || ''
        this.itAssetTableDetails.tableData = respone.data;
        this.itAssetTableDetails.count = count.data;
        this.itAssetTableDetails.loader = false;
      });
    } catch (error) {
      console.log(error);
      this.itAssetTableDetails.loader = false;
    }
  };

  handleIntentorySort = async (
    sortBy: string,
    order: string,
    pageNumber: number,
  ) => {
    try {
      this.itAssetTableDetails.loader = true;
      const reverseKeyMap = Object.fromEntries(
        Object.entries(sortNameReset).map(([key, value]) => [value, key]),
      );
      const headerName = reverseKeyMap[sortBy] || sortBy;
      const [respone, count] = await Promise.all([
        CRMService.ItAssetInventoryItemsSort(order, headerName, pageNumber),
        agent.updateCountOrder.updateCount(store.userStore.user?.id || ''),
      ]);
      runInAction(() => {
        respone.data.title =
          respone.data?.title?.split('~')[0]?.split('-')[0] || '';
        this.itAssetTableDetails.tableData = respone.data;
        this.itAssetTableDetails.count = count.inventoryCount;
        this.itAssetTableDetails.loader = false;
      });
    } catch (error) {
      console.log(error);
      this.itAssetTableDetails.loader = false;
    }
  };
  // handleCrmAssetSearchValues = async (pageNumber:number,pageSize:number,params:any[]) => {
  //   try {
  //     this.assetTracking.tableData.length = 0;
  //     const response  = await agent.CRMAssetTracking.searchCRMAsset(pageNumber, pageSize,params);
  //     const countResponse = await agent.CRMAssetTracking.crmCount();
  //     runInAction(() => {
  //   this.assetTracking.tableData = response.data;
  //   this.assetTracking.count = params.length > 0 ? 1 : countResponse.data.count;
  // })
  //   } catch (error) {
  //     console.log(error)
  //   }
  // }

  handleCrmAssetTracking = async (pageNumber: number, pagesize: number, params: any[]) => {
    try {
      this.assetTracking.loading = true;
      const [response, count] = await Promise.all([
        agent.CRMAssetTracking.searchCRMAsset(pageNumber, pagesize, params),
        agent.CRMAssetTracking.crmCount(),
      ]);
      const modifiedData = response.data.map((item: any) => ({
        ...item,
        edit: '', // Adding an empty string for 'edit'
        history: '', // Adding an empty string for 'history'
      }));
      runInAction(() => {
        this.assetTracking.tableData = modifiedData;
        this.assetTracking.count = count.data.count;
        this.assetTracking.loading = false
      });
    } catch (error) {
      console.log(error);
      this.assetTracking.loading = false
    }
  };
  handleCrmAssetSearch = async (data:any) => {
    try {
      this.assetTracking.loading = true
           const result:any[] = data === null ? [] : Object.entries(data).map(([key, value]) => ({
             headerName: key,
             searchValue: value || ''
            }));
            const response = await agent.CRMAssetTracking.searchCRMAsset(1,10,result)
            const resCount = await agent.CRMAssetTracking.assetSearchCount(result);
            this.assetTracking.tableData = response.data;
            this.assetTracking.pageNumber = 1;
            this.assetTracking.searchCount = resCount.data;
            // if(result.length > 0){
            //   this.assetTracking.count = response.data.length
            // }else{
            //   const countResponse = await agent.CRMAssetTracking.crmCount();
            //   this.assetTracking.count = countResponse.data.count
            // }
            this.assetTracking.loading = false
    } catch (error) {
      console.log(error)
    }
  }
  handleDeptList = async() => {
    try {
      const response  = await agent.CRMAssetTracking.DepartmentNameList();
      runInAction(()=>{
        this.assetTracking.deptList = response.data;
      })
    } catch (error) {
      console.log(error)
    }
  }
}
